import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

function calendarDay(value) {
    if (value == null || value === "") return null;
    const parsed = dayjs(value);
    if (!parsed.isValid()) return null;
    return parsed.format("YYYY-MM-DD");
}

export function toUtcStartOfDayIso(value) {
    const day = calendarDay(value);
    return day ? `${day}T00:00:00.000Z` : null;
}

export function toUtcExclusiveEndIso(value) {
    const day = calendarDay(value);
    if (!day) return null;
    const nextDay = dayjs.utc(`${day}T00:00:00.000Z`).add(1, "day").format("YYYY-MM-DD");
    return `${nextDay}T00:00:00.000Z`;
}

export function inclusiveStartFromStored(iso) {
    if (!iso) return null;
    const instant = dayjs.utc(iso);
    if (!instant.isValid()) return null;
    const startOfUtcDay = instant.startOf("day");
    if (instant.isSame(startOfUtcDay)) return startOfUtcDay.format("YYYY-MM-DD");
    return startOfUtcDay.add(1, "day").format("YYYY-MM-DD");
}

export function inclusiveEndFromStored(iso) {
    if (!iso) return null;
    const instant = dayjs.utc(iso);
    if (!instant.isValid()) return null;
    return instant.subtract(1, "millisecond").format("YYYY-MM-DD");
}

export function toFormDate(iso, { end = false } = {}) {
    const day = end ? inclusiveEndFromStored(iso) : inclusiveStartFromStored(iso);
    if (!day) return null;
    const [year, month, date] = day.split("-").map(Number);
    return dayjs(new Date(year, month - 1, date));
}

export function formatExchangeRatePeriod(fromIso, toIso) {
    const from = inclusiveStartFromStored(fromIso);
    if (!from) return "—";
    if (!toIso) return `${from} ~ 当前`;
    const to = inclusiveEndFromStored(toIso);
    return to ? `${from} ~ ${to}` : `${from} ~ 当前`;
}
